import { type ForwardedRef, forwardRef } from 'react'
import type { PatternFormatProps } from 'react-number-format'
import { PatternFormat } from 'react-number-format'

import type { InputProps } from '@/_components/ui/input'
import { Input } from '@/_components/ui/input'

type BirthDateInputProps = Omit<Partial<PatternFormatProps<InputProps>>, 'onChange'> & {
  onChange?: (value: string) => void
}

export const BirthDateInput = forwardRef(
  ({ onChange, ...props }: BirthDateInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <PatternFormat
        {...props}
        format="##/##/####"
        customInput={Input}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange?.(values.formattedValue)
        }}
      />
    )
  },
)

BirthDateInput.displayName = 'BirthDateInput'
